// extracted by mini-css-extract-plugin
module.exports = {"topImg":"index_topImg__q6_df","bottomImg":"index_bottomImg__S1_I_"};